export const accessHasExpired = dateString => {
  return new Date() > new Date(dateString);
};
